import { useTenant } from '../../components/Shell';
import { PageHeader } from '../../components/ui';
import { LegalHoldsCard } from '../../components/messages/SmartSettings';

/**
 * Legal holds on a page of their own (1.13.0, 2717): an archive-only company's admins keep them (their
 * Settings page is the phone system's). Everyone else finds the same card under Settings.
 */
export function TenantLegalHolds() {
  const { tenant } = useTenant();
  return (
    <>
      <PageHeader eyebrow="Company" title="Legal holds" />
      <div className="content">
        <LegalHoldsCard domain={tenant.domain} companyName={tenant.name} />
      </div>
    </>
  );
}
